import React, { useEffect, useState, useCallback } from "react";
import moment from "moment";
import { useTranslation } from 'react-i18next';
import { useStoreState, useStoreActions } from 'easy-peasy';


import { Row, Col, Card, CardBody } from "stories/layout";
import { Input } from "stories/forms";
import { Typography, Button, Link, IconButton, Modal, Spinner, BreadcrumbsDynamic } from "stories/components";
import { PageHeader, PageContainer } from "components/Page"
import { TableAuto } from "stories/tables"
import { useAppContext } from "contexts/AppContext"
import { round, roundScaleDecimals, DERIVATIVE_PRICE_DECIMALS } from "services/helpers"

import PortfolioEdit from "views/app/PortfolioEdit/PortfolioEdit"
import PreTransactionEdit from "views/app/PreTransactionEdit/PreTransactionEdit"
import PreOptionEdit from "views/app/PreOptionEdit/PreOptionEdit"
import { attachTerminationToPrimary, groupPartialTerminationPreOptions } from "views/app/PreOptionEdit/groupPreOptions"
import SplitTransactionEdit from "views/app/SplitTransactionEdit/SplitTransactionEdit"
import SplitTransactionGroupCreate from "views/app/SplitTransactionGroupCreate/SplitTransactionGroupCreate"
import { date } from "yup/lib/locale";
import { useTargetPortfolio } from "components/TargetPortfolioDialog/useTargetPortfolio"

const UnmadePreTransactions = (props) => {
  
  const { t } = useTranslation();
  const portfolios = useStoreState((state) => state.portfolio?.portfolios);
  const portfolio = useStoreState((state) => state.portfolio?.portfolio);
  // A pre-record is processed in its own portfolio (#1409). The forms take object.portfolio
  // first anyway; this keeps their fallback, the target, the same portfolio.
  const { forRow } = useTargetPortfolio();
  // The parent fetches the pre-records of every active portfolio; with several the portfolio
  // is shown on the row (#1409).
  const showPortfolio = useStoreState((state) => (state.portfolio?.activePortfolios?.length || 0) > 1);
  const account = useStoreState((state) => state.account?.account);

  const { getPortfolioName, getUserTypeName, getTransactionType } = useAppContext()
  
  const setPortfolio = useStoreActions((actions) => actions.portfolio.setPortfolio);

  const loading = useStoreState((state) => state.portfolio?.loading);
  const count = useStoreState((state) => state.portfolio?.count);
  const getPortfolios = useStoreActions((actions) => actions.portfolio.getPortfolios);

  const preTransactions = props?.preTransactions || []
  const preOptions = props?.preOptions || []


  
  const [filters, setFilters] = useState({
    limit: 30,
    offset:0,
  })
  
  const handleChange = ({target}) => {
    setFilters({
      ...filters,
      [target.name]: target.value,
    })
  }
  
  const paginationPrevious = () => {
    let offset = filters?.offset - filters?.limit;
    if (offset < 0) {
      offset = 0;
    }
    setFilters(f => ({
      ...f,
      offset: offset,
    }))
  }
  
  const paginationNext = () => {
    let offset = filters?.offset + filters?.limit;
    if (offset > filters?.count) {
      return
    }
    setFilters(f => ({
      ...f,
      offset: offset,
    }))
  }
  
  const headers = [

      // // { label: t("unmade_split_transactions_list_batch", "Erä id"), key: "batch"},
      // { label: t("unmade_split_transactions_list_split_id", "Split id"), key: "split_id"},
      // { label: t("unmade_split_transactions_list_instrument_name", "Instrumentti"), key: "instrument_name"},
      // // { label: t("unmade_split_transactions_list_batch_purchase_date", "Hankintapäivä"), key: "batch_purchase_date"},
      // // { label: t("unmade_split_transactions_list_batch_balance", "erän koko ennen splittiä"), key: "batch_balance"},
      // { label: t("unmade_split_transactions_list_split_dividend", "Kerroin"), key: "dividend"},
      // { label: t("unmade_split_transactions_list_split_date_effective", "SPLIT Päivä"), key: "date_effective"},
      // // { label: t("unmade_split_transactions_list_portfolio", "Salkku"), key: "portfolio"},




      // { label: t("unmade_pre_transactions_portfolio", "Salkku"), key: "portfolio"},
      ...(showPortfolio ? [{ label: <strong>{t("transactions_list_portfolio", "Salkku")}</strong>, key: "portfolio_name"}] : []),
      { label: <strong>{t("unmade_pre_transactions_date_transaction", "Tapahtumapäivä")}</strong>, key: "date_transaction"},
      { label: <strong>{t("unmade_pre_transactions_import_name", "Tuonti nimi")}</strong>, key: "import_name"},
      { label: <strong>{t("unmade_pre_transactions_ticker_symbol", "Tuonti symbol")}</strong>, key: "import_ticker_symbol"},
      { label: <strong>{t("unmade_pre_transactions_quantity", "Määrä")}</strong>, key: "quantity"},
      { label: <strong>{t("unmade_pre_transactions_price", "Hinta")}</strong>, key: "price"},
      { label: <strong>{t("unmade_pre_transactions_price_total", "Hinta yhteensä")}</strong>, key: "price_total"},
      { label: <strong>{t("unmade_pre_transactions_broker_name", "Välittäjä")}</strong>, key: "broker_name"},
      { label: <strong>{t("unmade_pre_transactions_reference_code", "Viitekoodi")}</strong>, key: "reference_code"},
      // { label: t("unmade_pre_transactions_commission_basic_amount", "Perusprovisio"), key: "commission_basic_amount"},
      // { label: t("unmade_pre_transactions_commission_percentage", "Prosenttipalkkio"), key: "commission_percentage"},
      // { label: t("unmade_pre_transactions_commission_total", "Provisio yhteensä"), key: "commission_total"},
      // { label: t("unmade_pre_transactions_currency_exchange_rate", "Valuuttakurssi"), key: "currency_exchange_rate"},
      // { label: t("unmade_pre_transactions_currency_label", "Valuutta"), key: "currency_label"},
      // { label: t("unmade_pre_transactions_date_settlement", "Maksupäivä"), key: "date_settlement"},
      // { label: t("unmade_pre_transactions_id", "Id"), key: "id"},
      // { label: t("unmade_pre_transactions_notes", "Muistiinpanot"), key: "notes"},
      // { label: t("unmade_pre_transactions_stock_market", "Pörssi"), key: "stock_market"},
      // { label: t("unmade_pre_transactions_type", "Tyyppi"), key: "type"},
      // { label: t("unmade_pre_transactions_user", "Käyttäjä"), key: "user"},
      // { label: t("unmade_pre_transactions_value_total", "Arvo yhteensä"), key: "value_total"},
      // { label: t("unmade_pre_transactions_related_model_type", "Liittyvä malli tyyppi"), key: "related_model_type"},
      // { label: t("unmade_pre_transactions_related_model_id", "Liittyvä malli id"), key: "related_model_id"},
      // { label: t("unmade_pre_transactions_stock_split", "Osakesplitti"), key: "stock_split"},
      // { label: t("unmade_pre_transactions_dividend_instance", "Osinko"), key: "dividend_instance"},
      // { label: t("unmade_pre_transactions_import_ticker", "Tuonti symbol"), key: "import_ticke_symbol"},
      // { label: t("unmade_pre_transactions_isin", "Isin"), key: "isin"},
      // { label: t("unmade_pre_transactions_name", "Nimi"), key: "name"},
      // { label: t("unmade_pre_transactions_related_model_type", "Liittyvä malli tyyppi"), key: "related_model_type"},
      // { label: t("unmade_pre_transactions_related_model_id", "Liittyvä malli id"), key: "related_model_id"},
      // { label: t("unmade_pre_transactions_user", "Käyttäjä"), key: "user"}, 
      // { label: t("unmade_pre_transactions_created", "Luotu"), key: "created"},
      // { label: t("unmade_pre_transactions_stock_split", "Osakesplitti"), key: "stock_split"},
      // { label: t("unmade_pre_transactions_dividend_instance", "Osinko"), key: "dividend_instance"},
      // { label: t("unmade_pre_transactions_processed", "Käsitelty"), key: "processed"},
      // { label: t("unmade_pre_transactions_file", "Tiedosto"), key: "file"},
      // { label: t("unmade_pre_transactions_notes", "Muistiinpanot"), key: "notes"},




    { label: <strong>{t("portfolios_list_actions", " ")}</strong>, key: "actions"},
  ];

  const preOptionsHeaders = [
    ...(showPortfolio ? [{ label: <strong>{t("transactions_list_portfolio", "Salkku")}</strong>, key: "portfolio_name"}] : []),
    { label: <strong>{t("unmade_pre_options_start_date", "Alkamispäivä")}</strong>, key: "start_date"},
    { label: <strong>{t("unmade_pre_options_end_date", "Päättymispäivä")}</strong>, key: "end_date"},
    { label: <strong>{t("unmade_pre_options_asset_name", "Kohde-etuus")}</strong>, key: "asset_name"},
    { label: <strong>{t("unmade_pre_options_derivative_type", "Johdannaistyyppi")}</strong>, key: "derivative_type"},
    { label: <strong>{t("unmade_pre_options_premium", "Preemio")}</strong>, key: "premium"},
    { label: <strong>{t("unmade_pre_options_strike_price", "Toteutushinta")}</strong>, key: "strike_price"},
    { label: <strong>{t("unmade_pre_options_broker_name", "Välittäjä")}</strong>, key: "broker_name"},
    { label: <strong>{t("portfolios_list_actions", " ")}</strong>, key: "actions"},
  ];

  const passPortfolio  = (id) => {
    // get query params id
      console.log("id", id)
      const filtered = portfolios.filter(o => o.id == id)
      if (filtered && filtered.length > 0) {
        setPortfolio(filtered[0])
      }
  }


  useEffect(() => {
    // getUnmadeSplitTransactions()
    }, [])
  
  
  
  
  const getTableRows = useCallback(() => {

    let data = preTransactions;



    return preTransactions && preTransactions.map((row, index) => {
      let batch_balance = Number(row[0]?.batch?.batch_balance)
      const originalRow = row
      return {
        ...row,
        _modalRow: originalRow,
        // split_id: row[0]?.splits?.id,
        // instrument_name: <Typography variant="h5" className="text-dark">{row[0]?.batch?.related_model?.name}</Typography>,
        portfolio_name: getPortfolioName(Number(row?.portfolio?.id ?? row?.portfolio)),
        date_transaction: moment(row?.date_transaction).format('DD.MM.YYYY'),
        import_name: (
          <strong className="text-dark text-lowercase">{row?.import_name}</strong>
        ),
        // dividend: row[0]?.splits?.dividend,
        actions: (
          <div className="d-flex justify-content-end">

          <Button name="process_split_transactions_button" className="btn-sm btn-action" color="secondary" onClick={() => openModalEdit(row)}>{t("unmade_split_transactions_list_process_button","Käsittele")}</Button>
          </div>
        ),
      }
    })
    

  }, [preTransactions, showPortfolio])

  const getPreOptionsTableRows = useCallback(() => {
    const grouped = groupPartialTerminationPreOptions(preOptions)
    return grouped.map((group) => {
      const row = group.primary
      const modalRow = attachTerminationToPrimary(group)
      return {
        ...row,
        derivative_action: group.isPartialPair ? "partial_event" : row.derivative_action,
        _modalPreOptionRow: modalRow,
        portfolio_name: getPortfolioName(Number(row?.portfolio?.id ?? row?.portfolio)),
        start_date: row?.start_date ? moment(row?.start_date).format('DD.MM.YYYY') : '',
        end_date: row?.end_date ? moment(row?.end_date).format('DD.MM.YYYY') : '',
        asset_name: <Typography variant="h5" className="text-dark">{row?.asset_name}</Typography>,
        derivative_type: row?.derivative_type === 2 ? t("Option") : t("Future"),
        premium: row?.premium ? roundScaleDecimals(row?.premium, DERIVATIVE_PRICE_DECIMALS) : '',
        strike_price: row?.strike_price ? roundScaleDecimals(row?.strike_price, DERIVATIVE_PRICE_DECIMALS) : '',
        broker_name: row?.broker_name || '',
        actions: (
          <div className="d-flex justify-content-end">
            <Button name="process_pre_option_button" className="btn-sm btn-action" color="secondary" onClick={() => openModalPreOptionEdit(modalRow)}>{t("unmade_pre_options_process_button","Käsittele")}</Button>
          </div>
        ),
      }
    })
  }, [preOptions, showPortfolio])
  
  // Modal: New/Edit portfolio
  
  const [modalEditOpen, setModalEditOpen] = useState(false)
  const [modalEditBatch, setModalEditBatch] = useState()

  // Modal: PreOption Edit
  const [modalPreOptionEditOpen, setModalPreOptionEditOpen] = useState(false)
  const [modalPreOptionEditBatch, setModalPreOptionEditBatch] = useState()
  
  const toggleModalEdit = () => {
    setModalEditOpen(s => !s);
  }
  
  const openModalEdit = (batch) => {
    forRow(batch?.portfolio)
    setModalEditOpen(true)
    setModalEditBatch(batch);
  }
  
  const modalEditResolve = () => {
    setModalEditOpen(false);
    // setModalEditBatch(null);
    // getUnmadeSplitTransactions()
    props.getTransactions()
    props.getPreTransactions()
    // props.setParentFilters({
    //   ...filters,
    //   update: props.parentfilters.update? true:false
    // })

  }
  
  const modalEditReject = () => {
    setModalEditOpen(false);
    setModalEditBatch(null);
  }

  // PreOption Modal functions
  const toggleModalPreOptionEdit = () => {
    setModalPreOptionEditOpen(s => !s);
  }
  
  const openModalPreOptionEdit = (batch) => {
    forRow(batch?.portfolio)
    setModalPreOptionEditOpen(true)
    setModalPreOptionEditBatch(batch);
  }
  
  const modalPreOptionEditResolve = () => {
    setModalPreOptionEditOpen(false);
    props.getTransactions()
    props.getPreTransactions()
    props.getPreOptions && props.getPreOptions()
  }
  
  const modalPreOptionEditReject = () => {
    setModalPreOptionEditOpen(false);
    setModalPreOptionEditBatch(null);
  }

  return (
    <>
        <Card className="shadow-sm mb-3">
          <CardBody className="p-2">
            <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-2">
              <PageHeader title={t("unmade_split_transactions_list_title","Käsittele saapuneet kirjaukset")} />
              <div className="d-flex align-items-center">
                <i className="fas fa-sort-amount-down mr-2" aria-hidden="true" />
                <Typography variant="h5" className="mb-0">{t("unmade_split_transactions_list_process_order","Vanhimmat ensin")}</Typography>
              </div>
            </div>
            <TableAuto
              showRowNumber={false}
              showId={false}
              checkboxes={false}
              headers={headers}
              headerColor={"light"}
              rows={getTableRows()}
              loading={loading}
              pagination={false}
              paginationPrevious={paginationPrevious}
              paginationNext={paginationNext}
              paginationOffset={filters?.offset}
              paginationLimit={filters?.limit}
              paginationCount={count}
              setFilters={setFilters}
              name={"preTransactions"}
              onRowClick={(r) => openModalEdit(r._modalRow)}
            />
          </CardBody>
        </Card>

        {preOptions && preOptions.length > 0 && (
          <Card className="shadow-sm mb-3">
            <CardBody className="p-2">
              <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-2">
                <PageHeader title={t("unmade_pre_options_title","Käsittele saapuneet johdannaiskirjaukset")} />
                <div className="d-flex align-items-center">
                  <i className="fas fa-sort-amount-down mr-2" aria-hidden="true" />
                  <Typography variant="h5" className="mb-0">{t("unmade_pre_options_process_order","Vanhimmat ensin maksupäivän mukaan")}</Typography>
                </div>
              </div>
              <TableAuto
                showRowNumber={false}
                showId={false}
                checkboxes={false}
                headers={preOptionsHeaders}
                headerColor={"light"}
                rows={getPreOptionsTableRows()}
                loading={loading}
                pagination={false}
                paginationPrevious={paginationPrevious}
                paginationNext={paginationNext}
                paginationOffset={filters?.offset}
                paginationLimit={filters?.limit}
                paginationCount={count}
                setFilters={setFilters}
                name={"preOptions"}
                onRowClick={(r) => openModalPreOptionEdit(r._modalPreOptionRow)}
              />
            </CardBody>
          </Card>
        )}
        
        <Modal
          title={t("portfolios_list_portfolio_title","Salkku")}
          showHeader={false}
          isOpen={modalEditOpen}
          toggleModal={toggleModalEdit}
          size="modal-xxl"
        >
          <PreTransactionEdit
            object={modalEditBatch}
            handleResolve={modalEditResolve}
            handleReject={modalEditReject}
          />
        </Modal>

        <Modal
          title={t("pre_option_edit_title","Johdannainen")}
          showHeader={false}
          isOpen={modalPreOptionEditOpen}
          toggleModal={toggleModalPreOptionEdit}
          size="modal-xxl"
        >
          <PreOptionEdit
            object={modalPreOptionEditBatch}
            handleResolve={modalPreOptionEditResolve}
            handleReject={modalPreOptionEditReject}
          />
        </Modal>

    </>
  );
}

export default UnmadePreTransactions;
